import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
/**
 * @ReactComponent
 * 表格底部区域
 *
 * @export
 * @class TableFooter
 * @extends {React.Component}
 */
var TableFooter = /** @class */ (function (_super) {
    tslib_1.__extends(TableFooter, _super);
    function TableFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableFooter.prototype.getChildContext = function () {
        return {
            table: {
                footer: true,
            },
        };
    };
    TableFooter.prototype.render = function () {
        return React.createElement("tfoot", tslib_1.__assign({}, this.props));
    };
    TableFooter.childContextTypes = {
        table: PropTypes.object,
    };
    return TableFooter;
}(React.Component));
export default TableFooter;
//# sourceMappingURL=TableFooter.js.map